export default "<canvas #canvasElement></canvas>\n"